import { useContext } from 'react';
import i18nContext from 'components/i18n-context';
import './CustomerLimitDetailsHeadRow.scss';

export const CUSTOMER_LIMIT_DETAILS_TABLE_HEADER = [
  {
    label: 'limitInfo'
  },
  {
    label: 'limitValue'
  },
  {
    label: 'groupName'
  },
  {
    label: 'createdAtAndUpdatedAt'
  },
  {
    label: 'status'
  },
  {
    label: 'actions'
  }
];

export const CustomerLimitDetailsHeadRow = () => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {CUSTOMER_LIMIT_DETAILS_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'customer-limit-group-details-table-head'}>
          <div className={'customer-limit-group-details-table-head-block'}>
            <span>{i18n.getMessage(`limits.details.table.header.${head.label}`)}</span>
          </div>
        </th>
      ))}
    </tr>
  );
};
